import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import VirtualElementPopover from './VirtualElementPopover';
import ClientProvider from './client';
export default createDemo(import.meta.url, VirtualElementPopover, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/popover/demos/virtual-element/VirtualElementPopover.tsx",
    "fileName": "VirtualElementPopover.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Popover from '@mui/material/Popover';\nimport type { PopoverProps } from '@mui/material/Popover';\nimport Typography from '@mui/material/Typography';\nimport Paper from '@mui/material/Paper';\n\nexport default function VirtualElementPopover() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [open, setOpen] = React.useState(false);\n  const [anchorEl, setAnchorEl] = React.useState<PopoverProps['anchorEl']>(null);\n\n  const handleClose = () => {\n    setOpen(false);\n  };\n\n  const handleMouseUp = () => {\n    const selection = window.getSelection();\n\n    // Skip if selection has a length of 0\n    if (!selection || selection.anchorOffset === selection.focusOffset) {\n      return;\n    }\n\n    const getBoundingClientRect = () => {\n      return selection.getRangeAt(0).getBoundingClientRect();\n    };\n\n    setOpen(true);\n\n    setAnchorEl({ getBoundingClientRect, nodeType: 1 });\n  };\n\n  const id = open ? 'virtual-element-popover' : undefined;\n\n  return (\n    <div>\n      <Typography aria-describedby={id} onMouseUp={handleMouseUp}>\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ipsum purus,\n        bibendum sit amet vulputate eget, porta semper ligula. Donec bibendum\n        vulputate erat, ac fringilla mi finibus nec. Donec ac dolor sed dolor\n        porttitor blandit vel vel purus. Fusce vel malesuada ligula. Nam quis\n        vehicula ante, eu finibus est. Proin ullamcorper fermentum orci, quis finibus\n        massa. Nunc lobortis, massa ut rutrum ultrices, metus metus finibus ex, sit\n        amet facilisis neque enim sed neque. Quisque accumsan metus vel maximus\n        consequat. Suspendisse lacinia tellus a libero volutpat maximus.\n      </Typography>\n      <Popover\n        id={id}\n        open={open}\n        anchorEl={anchorEl}\n        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}\n        onClose={handleClose}\n        disableAutoFocus\n      >\n        <Paper>\n          <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>\n        </Paper>\n      </Popover>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 60,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Popover from '@mui/material/Popover';\nimport type { PopoverProps } from '@mui/material/Popover';\nimport Typography from '@mui/material/Typography';\nimport Paper from '@mui/material/Paper';\n\nexport default function VirtualElementPopover() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [open, setOpen] = React.useState(false);\n  const [anchorEl, setAnchorEl] = React.useState<PopoverProps['anchorEl']>(null);\n\n  const handleClose = () => {\n    setOpen(false);\n  };\n\n  const handleMouseUp = () => {\n    const selection = window.getSelection();\n\n    // Skip if selection has a length of 0\n    if (!selection || selection.anchorOffset === selection.focusOffset) {\n      return;\n    }\n\n    const getBoundingClientRect = () => {\n      return selection.getRangeAt(0).getBoundingClientRect();\n    };\n\n    setOpen(true);\n\n    setAnchorEl({ getBoundingClientRect, nodeType: 1 });\n  };\n\n  const id = open ? 'virtual-element-popover' : undefined;\n\n  return (\n    <div>\n      <Typography aria-describedby={id} onMouseUp={handleMouseUp}>\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ipsum purus,\n        bibendum sit amet vulputate eget, porta semper ligula. Donec bibendum\n        vulputate erat, ac fringilla mi finibus nec. Donec ac dolor sed dolor\n        porttitor blandit vel vel purus. Fusce vel malesuada ligula. Nam quis\n        vehicula ante, eu finibus est. Proin ullamcorper fermentum orci, quis finibus\n        massa. Nunc lobortis, massa ut rutrum ultrices, metus metus finibus ex, sit\n        amet facilisis neque enim sed neque. Quisque accumsan metus vel maximus\n        consequat. Suspendisse lacinia tellus a libero volutpat maximus.\n      </Typography>\n      <Popover\n        id={id}\n        open={open}\n        anchorEl={anchorEl}\n        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}\n        onClose={handleClose}\n        disableAutoFocus\n      >\n        <Paper>\n          <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>\n        </Paper>\n      </Popover>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 60,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Popover",
      "@mui/material/Typography",
      "@mui/material/Paper"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
